import gql from 'graphql-tag';

export const UPDATE_JOB = gql`
  mutation UpdateJob($updateJobId: String, $job: JobInput) {
    UpdateJob(id: $updateJobId, job: $job) {
      id
      orderId
      origin {
        name
        location
      }
      destination {
        name
        location
      }
      searchParams {
        city
        range
      }
      assignedRiderId
      jobDate
      deliveryCharge {
        baseFee
        tax
        total
      }
      jobStatus
      tipAmount
    }
  }
`;

export const CREATE_JOB = gql`
  mutation CreateJob($job: JobInput) {
    CreateJob(job: $job) {
      id
      orderId
      jobDate
      origin {
        name
        location
      }
      destination {
        name
        location
      }
      searchParams {
        city
        range
      }
      assignedRiderId
      jobDate
      deliveryCharge {
        baseFee
        tax
        total
      }
      jobStatus
      tipAmount
    }
  }
`;

export const UPDATE_ORDER_DELIVERY_DETAILS = gql`
  mutation UpdateOrderDeliveryDetails(
    $orderId: String
    $businessId: String
    $deliveryDetails: DeliveryDetailsInput
  ) {
    UpdateOrderDeliveryDetails(
      orderId: $orderId
      businessId: $businessId
      deliveryDetails: $deliveryDetails
    ) {
      orderId
      uiId
      businessInfo {
        businessId
        businessName
        phoneNumber
      }
      merchantId
      diners {
        participantName
        phone
        address {
          id
          zip
          line1
          line2
          state
          city
          timeZone
          country
          tag
          coordinates {
            latitude
            longitude
          }
        }
      }
      deliveryDetails {
        job {
          id
          orderId
          jobDate
          assignedRiderId
          jobStatus
        }
        riderDetails {
          id
          name
          primaryContact
        }
      }
    }
  }
`;
